import { defineMessages } from 'react-intl'

export default defineMessages({
  appUserInterface: {
    id: 'CatalogAppInstanceForm.AppUserInterface',
    defaultMessage: 'User Interface'
  },
  appUserInterfaceDescription: {
    id: 'CatalogAppInstanceForm.AppUserInterfaceDescription',
    defaultMessage: 'This allows your employees to interact with a front-end app interface.'
  },
  subcomponentDescriptionOn: {
    id: 'CatalogAppInstanceForm.AppUserInterfaceDescriptionOn',
    defaultMessage: 'This feature is currently ON.'
  },
  subcomponentDescriptionOff: {
    id: 'AppInstanceForm.DescriptionOff',
    defaultMessage: 'This feature is currently OFF.'
  },
  comingSoon: {
    id: 'SpacesPage.ComingSoon',
    defaultMessage: 'Coming Soon!'
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  customAppIcon: {
    id: 'CatalogAppInstanceForm.CustomAppIcon',
    defaultMessage: 'Custom App Icon'
  },
  customAppName: {
    id: 'CatalogAppInstanceForm.CustomAppName',
    defaultMessage: 'Custom App Name'
  },
  customizeNameAndIcon: {
    id: 'CatalogAppInstanceForm.CustomizeNameAndIcon',
    defaultMessage: 'Customize App Name and Icon'
  },
  customAppNamePlaceholder: {
    id: 'CatalogAppInstanceForm.CustomNamePlaceholder',
    defaultMessage: `Enter your company's name for the app`
  },
  customAppIconPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.IconURL.Placeholder',
    defaultMessage: 'https://www.exampleurl.com/appLogo.png'
  },
  disableCheck: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisableCheck',
    defaultMessage: 'Do you really want to disable?'
  },
  disableConfirm: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisableConfirm',
    defaultMessage: 'Yes, disable'
  },
  disablingSmartNotifications: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisablingSmartNotifications',
    defaultMessage: 'Disabling this will delete all past or pending notifications for users.'
  },
  disablingAppUserInterface: {
    id: 'SpaceAppsPage.AppCatalog.Installation.DisablingAppUserInterface',
    defaultMessage:
      'Disabling this will remove configuration data and user access to this app, and it may remove associated log data.'
  },
  audienceTargeting: {
    id: 'SpaceAppsPage.AppCatalog.Installation.AudienceTargeting',
    defaultMessage: 'Audience Targeting'
  },
  audienceTargetingDescription: {
    id: 'AppInstanceForm.AudienceTargetingDescription',
    defaultMessage: 'All Members of your organization will receive the app.'
  },
  audienceTargetingSubComponentDescription: {
    id: 'AppInstanceForm.AudienceTargetingSubComponentDescription',
    defaultMessage: 'Turn on to update.'
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete'
  },
  functionalityFeatures: {
    id: 'SpaceAppsPage.AppCatalog.Installation.FunctionalityFeatures',
    defaultMessage: 'App Functionality & Features'
  },
  headerSubtitle: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Subtitle',
    defaultMessage: 'Complete the following to install {appName} in {spaceName}'
  },
  install: {
    id: 'Install',
    defaultMessage: 'Install'
  },
  internalBrandingOverride: {
    id: 'CatalogAppInstanceForm.InternalBrandingOverride',
    defaultMessage: 'Internal Branding Override'
  },
  invalidEmail: {
    id: 'FormError.invalidEmail',
    defaultMessage: 'Please enter a valid email.'
  },
  invalidImage: {
    id: 'FormError.invalidImage',
    defaultMessage: 'Please enter a valid Image URL. Valid image types are gif, jpg, jpeg, and png.'
  },
  invalidURL: {
    id: 'FormError.InvalidURL',
    defaultMessage: 'Please enter a valid URL.'
  },
  pollingInterval: {
    id: 'CatalogAppInstanceForm.PollingSchedule',
    defaultMessage: 'Polling Schedule Interval'
  },
  pollingTooltip: {
    id: 'CatalogAppInstanceForm.PollingTooltip',
    defaultMessage: 'Set the time interval for the app to check for updated external information'
  },
  polling1MinuteDisplay: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Polling1MinuteDisplay',
    defaultMessage: '1 minute'
  },
  polling30MinuteDisplay: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Polling30MinuteDisplay',
    defaultMessage: '30 minutes'
  },
  polling1HourDisplay: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Polling1HourDisplay',
    defaultMessage: '1 hour'
  },
  polling6HourDisplay: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Polling6HourDisplay',
    defaultMessage: '6 hours'
  },
  polling12HourDisplay: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Polling12HourDisplay',
    defaultMessage: '12 hours'
  },
  polling24HourDisplay: {
    id: 'SpaceAppsPage.AppCatalog.Installation.Polling24HourDisplay',
    defaultMessage: '24 hours'
  },
  referenceGuide: {
    id: 'CatalogAppInstanceForm.ReferenceGuide',
    defaultMessage: 'Questions, consult our Reference Guide'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  requiredSymbol: {
    id: 'Asterisk',
    defaultMessage: '*'
  },
  settingsAccessAudience: {
    id: 'SpaceAppsPage.AppCatalog.Installation.SettingsAccessAudience',
    defaultMessage: 'Settings & Access'
  },
  smartNotifications: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.SmartNotifications',
    defaultMessage: 'Smart Notifications'
  },
  smartNotificationsDescription: {
    id: 'AppInstanceForm.SmartNotificationsDescription',
    defaultMessage:
      'Smart Notifications are personalized and contextual communications. Examples include: approvals, alerts, and task-oriented notifications.'
  },
  update: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  webHookUrl: {
    id: 'CatalogAppInstanceForm.WebHookURL',
    defaultMessage: 'Web Hook URL'
  },
  validationWarning: {
    id: 'CatalogAppInstanceForm.FormValidationError.ValidationWarning',
    defaultMessage: 'Please complete all required fields above.'
  },
  logs: {
    id: 'CatalogAppInstanceForm.Logs',
    defaultMessage: 'View Logs'
  }
})
